import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import * as React from 'react'
import { OrganizationBilling } from './OrganizationBilling'
import { PaygroupBillingList } from './PaygroupBilling'
import { UnifiedBillingForm } from './UnifiedBillingForm'

type ConnectBillingProps = {
  org: OrganizationDetailFragment
}
/**
 * Component for connecting billing methods to an organization - mainly responsible
 * for setting hasUnifiedBilling and updating UI in response
 */
export const ConnectBilling = ({ org }: ConnectBillingProps) => {
  return (
    <>
      <UnifiedBillingForm org={org} />
      {org.billing?.hasUnifiedBilling ? <OrganizationBilling org={org} /> : <PaygroupBillingList org={org} />}
    </>
  )
}
